import React from "react";
import Footer from "../Footer";
import { SCNeedHelp } from "./css";
import { connect } from "react-redux";
import { loadPageData } from "../../actions";
import { Nav } from "../Nav";

class NeedHelp extends React.Component<any, any> {
  render() {

    return (
      <SCNeedHelp>
        <Nav activePage="account" />
        <Footer />
      </SCNeedHelp>
    );
  }
}


export default NeedHelp;
